import { getENV } from '../../utils/env';

export const getOgScriptUrl = () => {
    const {
        NEXT_PUBLIC_OG_STATIC_DOMAIN,
        NEXT_PUBLIC_OG_MERCHANT_ID_CA,
        NEXT_PUBLIC_OG_MERCHANT_ID,
        NEXT_PUBLIC_LOCALE,
    } = getENV();

    const MERCHANT_ID = NEXT_PUBLIC_LOCALE === 'en-CA' ? NEXT_PUBLIC_OG_MERCHANT_ID_CA : NEXT_PUBLIC_OG_MERCHANT_ID;

    return `${NEXT_PUBLIC_OG_STATIC_DOMAIN}/${MERCHANT_ID}/msi.js`;
};
